export const QUICK_APPLY_USER = {
  EXIST: 'User is already exist',
  ALREADY_APPLIED: 'You have already applied for a Job',
  ALREADY_RECEIVED: 'Thanks, we have already received your application for this job'
};

export const isAlreadyAppliedMessage = (message) =>
  [QUICK_APPLY_USER.ALREADY_APPLIED, QUICK_APPLY_USER.ALREADY_RECEIVED].includes(message?.trim());
